import './Segment.css'

import { IonCard, IonCardContent, IonSegment } from '@ionic/react';

interface Props {
    defaultSlide: any,
    change: any
}

const Segment: React.FC<Props> = (props) => {
    return <IonCard className="segment">
        <IonCardContent>
            <IonSegment value={props.defaultSlide} onIonChange={props.change}>
                {props.children}
            </IonSegment>
        </IonCardContent>
    </IonCard>
}

export default Segment;